import { AxiosResponse } from 'axios';
import { createRequestAction, RequestAction } from 'core/utils/actionUtils';
import { Dispatch } from 'redux';
import { axiosRequest } from '../../core/axios';
import { LanguageModel } from 'core/languages/languages.model';

export const ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST: RequestAction = createRequestAction('GET_ALL_AVAILABLE_LANGUAGES_LIST_REQUEST');

export const fetchAllLanguages = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST.REQUEST });

    const request = await axiosRequest.get<any, AxiosResponse<LanguageModel[]>>("/v2/languages");

    dispatch({ type: ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST.SUCCESS, payload: request.data });
    return request.data;
  } catch (e) {
    dispatch({ type: ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST.ERROR, payload: e });
    throw e;
  }
};